<template>
  <div ref="chart">
    <Chart :height="height" :id="id" :option="option" :route="route"
            :width="width" :extendData="extendData" :spaceId="spaceId" :tagId="tagId"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';

export default {
  name: "PieChart",
  components: {Chart},
  props: {
    route: {
      type: String,
      default: ""
    },
    data: {
      type: Array,
      default: () => []
    },
    extendData: null,
    spaceId: {
      type: String,
      default: null
    },
    tagId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      id: "pieChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  watch: {
    data() {
      this.getOption();
    }
  },
  mounted() {
    this.getOption()
  },
  methods: {
    getOption: function () {
      let colorList = ['#FEDB5B', '#49A4F3', '#FF8373', '#afa3f5', '#00d488', '#3feed4', '#3bafff', "rgb(255, 163, 153)", "rgb(255, 121, 153)", 'rgb(255, 132, 48)', 'rgb(255, 176, 63)', 'rgb(61, 186, 45)', 'rgb(43, 166, 254)', 'rgb(255,222,0)', 'rgb(255,128,0)'];
      const that = this
      
      // 检查是否所有数据都是零
      const isAllZero = this.data.every(item => !item.value || item.value === 0);
      
      // 如果所有数据都是零，创建均分数据但显示为绿色
      let displayData = this.data;
      if (isAllZero && this.data.length > 0) {
        displayData = this.data.map(item => ({
          ...item,
          value: 1  // 给每个项赋值1，使其均分显示
        }));
      }
      
      // 正常显示数据
      this.option = {
        grid: {
          top: '10%',
        },
        tooltip: {
          trigger: 'item',
          formatter(params) {
            if (params.name !== "") {
              // 如果所有数据都是0，显示原始值0而不是1
              if (isAllZero) {
                const originalItem = that.data.filter(item => item.name === params.name)[0]
                return params.name + "：" + (originalItem ? originalItem.value || 0 : 0);
              }
              return params.name + "：" + params.value;
            }
          }
        },
        series: [{
          type: 'pie',
          clockwise: true,
          avoidLabelOverlap: false,
          hoverOffset: 5,
          itemStyle: {
            normal: {
              fontSize: 12,
              color: function (params) {
                // 如果所有数据都是0，统一显示绿色
                if (isAllZero) {
                  return '#00d468';
                }
                if (params.data.color) {
                  return params.data.color;
                }
                return colorList[params.dataIndex % colorList.length]
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          label: {
            normal: {
              show: false
            }
          },
          data: displayData,
          z: 2
        }, {
          type: 'pie',
          radius: ['80%', '0'],
          hoverAnimation: false,
          clockWise: false,
          itemStyle: {
            normal: {
              shadowBlur: 20,
              shadowColor: isAllZero ? 'rgba(0, 212, 136, .1)' : 'rgba(73, 164, 243, .1)',
              color: isAllZero ? 'rgba(0, 212, 136, .1)' : 'rgba(73, 164, 243, .1)',
            }
          },
          label: {
            show: false
          },
          data: [0],
          z: 1
        }],
        legend: {
          show: true,
          icon: "circle",
          orient: 'vertical',
          color: "#fff",
          textStyle: {
            color: "#fff"
          },
          data: this.data,
          formatter(name) {
            const item = that.data.filter(item => item.name === name)[0]
            return name + '(' + (item ? item.value || 0 : 0) + ')';
          }
        },
      };
    },
  },
}
</script>

<style scoped>

</style>
